import React from 'react';
import {
    Box, Paper, Typography, Grid, Chip, Stack
} from '@mui/material';
import {
    TrendingUp as TrendingUpIcon,
    TrendingDown as TrendingDownIcon,
    Warning as WarningIcon,
    Info as InfoIcon,
    ShowChart as ChartIcon
} from '@mui/icons-material';

const AIInsightsWidget = ({ insights }) => {
    if (!insights || insights.length === 0) {
        return (
            <Paper sx={{ p: 4, textAlign: 'center', bgcolor: 'grey.50' }}>
                <ChartIcon sx={{ fontSize: 48, color: 'grey.400', mb: 2 }} />
                <Typography variant="body1" color="text.secondary">
                    Nenhum insight gerado ainda.
                </Typography>
                <Typography variant="body2" color="text.disabled">
                    Importe mais dados históricos para análise estatística.
                </Typography>
            </Paper>
        );
    }

    const getIcon = (tipo, categoria) => {
        if (tipo === 'Alerta') return <WarningIcon />;
        if (categoria === 'Crescimento') return <TrendingUpIcon />;
        if (categoria === 'Redução') return <TrendingDownIcon />;
        return <InfoIcon />;
    };

    const getColor = (tipo, categoria) => {
        if (tipo === 'Alerta') return 'error';
        if (categoria === 'Crescimento') return 'error'; // Custo subindo é ruim
        if (categoria === 'Redução') return 'success'; // Custo caindo é bom
        return 'info';
    };

    const getBorderColor = (tipo, categoria) => {
        if (tipo === 'Alerta') return 'error.main';
        if (categoria === 'Crescimento') return 'error.main';
        if (categoria === 'Redução') return 'success.main';
        return 'info.main';
    };

    return (
        <Grid container spacing={2}>
            {insights.map((insight, index) => {
                const color = getColor(insight.tipo, insight.categoria);
                const borderColor = getBorderColor(insight.tipo, insight.categoria);

                return (
                    <Grid item xs={12} sm={6} lg={4} key={index}>
                        <Paper
                            elevation={1}
                            sx={{
                                p: 2,
                                borderLeft: 4,
                                borderColor: borderColor,
                                height: '100%',
                                transition: 'all 0.2s',
                                '&:hover': {
                                    elevation: 4,
                                    transform: 'translateY(-2px)'
                                }
                            }}
                        >
                            <Stack direction="row" justifyContent="space-between" alignItems="flex-start" mb={1}>
                                <Stack direction="row" alignItems="center" spacing={1}>
                                    <Box sx={{ color: `${color}.main` }}>
                                        {getIcon(insight.tipo, insight.categoria)}
                                    </Box>
                                    <Typography
                                        variant="overline"
                                        sx={{
                                            fontWeight: 'bold',
                                            color: `${color}.main`,
                                            lineHeight: 1.2
                                        }}
                                    >
                                        {insight.categoria}
                                    </Typography>
                                </Stack>
                                <Chip
                                    label={insight.centro}
                                    size="small"
                                    variant="outlined"
                                    sx={{ fontSize: '0.7rem' }}
                                />
                            </Stack>

                            <Typography
                                variant="body2"
                                sx={{
                                    fontWeight: 600,
                                    mb: 0.5,
                                    color: 'text.primary'
                                }}
                            >
                                {insight.mensagem}
                            </Typography>

                            <Typography
                                variant="caption"
                                color="text.secondary"
                                sx={{ display: 'block' }}
                            >
                                {insight.detalhe}
                            </Typography>
                        </Paper>
                    </Grid>
                );
            })}
        </Grid>
    );
};

export default AIInsightsWidget;
